import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import React from "react";
import { useHistory, Link } from "react-router-dom";
import * as yup from "yup";
import ValidateDialog from "./ValidateDialog";
import API from "@/api/serverCall";
import Button from "@/components/Button";

import { queryStringGetter } from "@/utils/global";
import { NotFound } from "@/views/NotFound";

export default function ResetPassword({ location }: any) {
	const history = useHistory();
	const { enqueueSnackbar } = useSnackbar();

	const [Mailvalidate, setMailvalidate] = React.useState(true);
	const urlSearchValue = queryStringGetter(location.search);

	const handleModalClose = () => {
		setMailvalidate(false);
	};

	const editPasswordFunc = (password: string) => {
		// for loading
		try {
			const requestData = {
				password,
				token: urlSearchValue.token,
			};
			API.PATCH<string>({
				link: `/user/signIn/resetPassword`, // 두잉랩서버 로그인토큰발급 api임
				body: requestData,
				loginRequest: true,
			})
				.then((response) => {
					enqueueSnackbar("비밀번호가 변경되었습니다", {
						variant: "info",
					});
					history.push("/auth/login");
				})
				.catch((error) => {
					enqueueSnackbar("일시적인오류입니다.", {
						variant: "info",
					});
					history.push(`/auth/resetPassword/?token=${urlSearchValue.token}`);
				});
		} catch (error) {
			console.error(error);
		}
	};

	const checkMailvalidate = (token: any) => {
		// for loading
		try {
			const requestData = {
				token,
			};
			API.POST<string>({
				link: `/common/verify/email`,
				body: requestData,
				loginRequest: true,
			})
				.then((response) => {
					setMailvalidate(true);
				})
				.catch((error) => {
					setMailvalidate(false);
				});
		} catch (error) {
			console.error(error);
		}
	};
	const validationSchema = yup.object({
		newPassword: yup
			.string()
			.required("새로운 비밀번호를 입력해주세요")
			.matches(
				/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$|^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}$|^(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,20}$/,
				"8~20자 사이, 영문(대소문자)+숫자+특수문자 중 2종류 이상을 조합하여 사용할 수 있습니다",
			),
	});
	const formik = useFormik({
		initialValues: {
			newPassword: "",
			confirmPassword: "",
		},
		validationSchema,
		onSubmit: (values) => {
			if (values.newPassword === values.confirmPassword) {
				editPasswordFunc(values.newPassword);
			}
		},
	});

	React.useEffect(() => {
		if (urlSearchValue.token) {
			checkMailvalidate(urlSearchValue.token);
		}
	}, [urlSearchValue.token]);

	return urlSearchValue.token ? (
		<div
			style={{
				width: "35rem",
				margin: "10rem  auto ",
				display: "flex",
				flexDirection: "column",
				textAlign: "center",
			}}
		>
			<ValidateDialog
				Mailvalidate={Mailvalidate}
				handleModalClose={handleModalClose}
			/>
			<form onSubmit={formik.handleSubmit}>
				<h1 style={{ marginBottom: "3rem" }}>비밀번호 변경페이지</h1>
				<Box sx={{ width: "100%", typography: "body1", margin: "auto" }}>
					<div>
						<div>
							<Box
								sx={{
									maxWidth: "100%",
									marginBottom: "1rem",
								}}
							>
								<span
									style={{
										display: "block",
										textAlign: "left",
									}}
								>
									새로운 비밀번호
								</span>
								<TextField
									fullWidth
									helperText={
										formik.touched.newPassword &&
										formik.errors.newPassword
									}
									id="newPassword"
									name="newPassword"
									type="password"
									value={formik.values.newPassword}
									onChange={formik.handleChange}
									error={
										formik.touched.newPassword &&
										Boolean(formik.errors.newPassword)
									}
								/>
								<span
									style={{
										display: "block",
										textAlign: "left",
										marginTop: "1rem",
									}}
								>
									새로운 비밀번호 확인
								</span>
								<TextField
									fullWidth
									helperText={
										formik.touched.confirmPassword &&
										formik.errors.confirmPassword
									}
									id="confirmPassword"
									name="confirmPassword"
									value={formik.values.confirmPassword}
									onChange={formik.handleChange}
									type="password"
									error={
										formik.touched.confirmPassword &&
										Boolean(formik.errors.confirmPassword)
									}
								/>
								{formik.values.confirmPassword !==
									formik.values.newPassword && (
									<span
										style={{
											marginTop: "1rem",
											display: "block",
											color: "red",
											fontSize: "0.9rem",
											textAlign: "left",
										}}
									>
										비밀번호가 일치하지 않습니다
									</span>
								)}
							</Box>
							<Button
								variant="contained"
								backgroundColor="#0071E3"
								sx={{
									height: "3.5rem",
									marginBottom: "2rem",
									fontWeight: "bold",
									fontSize: "1.2rem",
								}}
								fullWidth={true}
								type="submit"
							>
								비밀번호 재설정
							</Button>
						</div>

						<Link to="/auth/login" style={{ color: "#0071E3" }}>
							로그인화면 돌아가기
						</Link>
					</div>
				</Box>
			</form>
		</div>
	) : (
		<NotFound />
	);
}
